import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { postFleetsUuidFences } from "@src/api"
import FleetGeofenceEditor from "@src/settings/geofence/components/FleetGeofenceEditor"
import { showToastMessage } from "@src/toast/useToast"

export const CreateFleetGeofenceScreen: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { partnerUuid, fleetUuid } = useParams()
  const [searchParams] = useSearchParams()
  const fleetName = searchParams.get("fleetName") || "-"

  return (
    <FleetGeofenceEditor
      header={t("settings.fence.new_fence")}
      actionLabel={t("settings.fence.create")}
      onSubmit={async (name, coordinates) => {
        if (!partnerUuid || !fleetUuid) return
        const stringPaths = coordinates.map((latLng) => `[${latLng.lat}, ${latLng.lng}]`)
        const body = { fence: { kind: "classic", fencingposts: `[${stringPaths}]`, name } }
        const { response } = await postFleetsUuidFences(partnerUuid, fleetUuid, body)
        if (response.ok) {
          const title = t("settings.fence.toast.create_title")
          const text = t("settings.fence.toast.create_text", { name, fleet: fleetName })
          showToastMessage(title, text, true)
          navigate(`/${partnerUuid}/settings/geofences`)
        } else {
          const title = t("settings.fence.toast.create_title")
          const text = t("settings.fence.validate.error_create")
          showToastMessage(title, text, true)
        }
      }}
    />
  )
}

export default CreateFleetGeofenceScreen
